import { useBaseStore } from "@/stores/base";

export const HEALTH_CHECK_URL = "/api/health";
export const HEALTH_CHECK_TIMEOUT_MS = 5000;

let pendingCheck: Promise<boolean> | null = null;

/**
 * Pings the health endpoint and flags the backend as unreachable when no HTTP
 * response comes back at all (timeout or network error). Production servers
 * silently drop traffic from non-whitelisted IPs, while the frontend itself is
 * served from the service worker cache, so requests otherwise hang forever.
 *
 * Any HTTP response, even an error status, means the server is reachable.
 * Concurrent calls share a single in-flight request.
 */
export const checkBackendReachability = (): Promise<boolean> => {
	if (pendingCheck) {
		return pendingCheck;
	}

	pendingCheck = fetch(HEALTH_CHECK_URL, {
		cache: "no-store",
		credentials: "same-origin",
		signal: AbortSignal.timeout(HEALTH_CHECK_TIMEOUT_MS),
	})
		.then(() => true)
		.catch(() => false)
		.then((isReachable) => {
			useBaseStore().isBackendUnreachable = !isReachable;
			return isReachable;
		})
		.finally(() => {
			pendingCheck = null;
		});

	return pendingCheck;
};
